export const CENTRAL_ACCOUNT_ID = 'CENTRAL001';

export const isCentralAccount = (accountId: string) => accountId === CENTRAL_ACCOUNT_ID
